var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Switch } from '@blueprintjs/core';
export const Lightswitch = (_a) => {
    var { enabled = true, label, onClick } = _a, rest = __rest(_a, ["enabled", "label", "onClick"]);
    const [switchEnabled, setswitchEnabled] = useState(enabled);
    const handleChange = () => {
        setswitchEnabled(!switchEnabled);
        if (onClick) {
            onClick(!switchEnabled);
        }
    };
    return (React.createElement(Switch, Object.assign({ checked: switchEnabled, labelElement: React.createElement("span", null, label), onChange: handleChange, large: true }, rest)));
};
//# sourceMappingURL=Lightswitch.js.map